Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.GreetingsText = function (_a) {
    var text = _a.text, _b = _a.alignStyle, alignStyle = _b === void 0 ? 'inherit' : _b, fontSize = _a.fontSize;
    return (React.createElement("div", { className: "greetings-wrapper", style: { textAlign: alignStyle } },
        React.createElement("div", { className: "greetings-text", style: fontSize && { fontSize: fontSize } },
            ' ',
            text,
            ' ')));
};
